"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var config;
(function (config) {
    var console;
    (function (console) {
        console.LOG_LEVEL = {
            PRODUCTION: 0,
            ERRORS: 1,
            VERBOSE: 2
        };
        console.logLevel = console.LOG_LEVEL.PRODUCTION;
        console.methodsData = {
            log: { save: false, logLevel: console.LOG_LEVEL.VERBOSE },
            info: { save: false, logLevel: console.LOG_LEVEL.VERBOSE },
            warn: { save: false, logLevel: console.LOG_LEVEL.VERBOSE },
            error: { save: true, logLevel: console.LOG_LEVEL.ERRORS }
        };
    })(console = config.console || (config.console = {}));
})(config = exports.config || (exports.config = {}));
